import { isEmpty } from "lodash";
import React, { useEffect, useState } from "react";
import SportBookMatchInner from "../matchDetail/SportBookMatchInner";
import AuthContext from "../../context/AuthContext";
import { useContextSelector } from "use-context-selector";
import useScrollToItem from "../../component/Scroll";

const SportBookFav = ({
  matchSportBook,
  data,
  betSlipObject,
  showBetDialog,
  object,
  addToFavioute,
  user,
  position,
  setShowBetDialog,
  setBetSlipObject,
  setLimit,
  setToastObject,
  activeOuter,
  handleActive,
}) => {
  const parlyBet = useContextSelector(AuthContext, (ctx) => {
    return ctx.parlyBet;
  });
  const [active, setActive] = useState(
    Array.from({ length: 101 }, (_, i) => i)
  );
  const [sportBook, setSportBook] = useState([]);
  const [selected, setSelected] = useState("");
  const [favouriteList, setFavouriteList] = useState([]);
  const sportBookCheck = (parlyBet, detail, res) => {
    if (isEmpty(user)) {
      return "";
    } else {
      let find = parlyBet?.find((res) => {
        return res?.newEventId == detail?.eventId;
      });
      if (!isEmpty(find)) {
        return find?.sportsBookSelectionObject?.id == res?.id
          ? "active-sportBook-parly"
          : "";
      } else {
        return "";
      }
    }
  };
  useEffect(() => {
    if (matchSportBook?.length > 0 || data?.length > 0) {
      let updated = data?.map((res) => {
        let obj =
          matchSportBook?.length > 0
            ? matchSportBook?.find((item) => {
                return item?.id == res?.selectionId;
              })
            : {};
        if (isEmpty(obj)) {
          return {
            ...res,
            name: res.fancyName,
            marketName: res?.fancyName,
          };
        } else {
          return {
            ...res,
            odds: !isEmpty(obj) ? obj : {},
            ...obj,
            fancyName: res.name,
          };
        }
      });
      setFavouriteList(
        updated?.map((res) => {
          return res?.id;
        })
      );
      setSportBook(updated);
    }
  }, [matchSportBook, data]);

  let localLimit = {
    maxAmount: 1000,
    maxProfit: 10000,
    minAmount: 1,
    oddsLimit: 10,
  };
  const scrollToItem = useScrollToItem("#header"); // Pass header selector
  const handelChange = (odds, item, res, e) => {
    if (!isEmpty(user)) {
      if (odds > 0) {
        setShowBetDialog(true);
        scrollToItem(e.currentTarget);
        let obj = {
          odds: odds,
          eventId: object?.eventId,
          marketId: object?.marketId,
          teamName: res?.selectionName,
          item: { ...item },
          playType: "sportBook",
          object: {
            ...res,
          },
        };
        setLimit(localLimit);
        setBetSlipObject((prev) => ({ ...prev, ...obj }));
      }
    } else {
      setToastObject({
        type: "warning",
        title: "Warning",
        message: "Please login to place your bet!",
        status: true,
      });
    }
  };

  return (
    sportBook?.filter((res) => {
      return res?.sportsBookSelection?.length > 0;
    })?.length > 0 && (
      <div data-v-b7a97d9f className="s-pb-1">
        <div className="s-relative s-py-12px s-pr-14px s-pl-7px s-text-sm s-text-primary s-bg-primary s-rounded-3px s-cursor-pointer s-transition-all s-duration-300 s-rounded-b-none">
          <div className="s-flex s-justify-start s-items-center">
            <div className="s-flex s-flex-1">
              <span className="s-pr-2 s-text-16px s-font-bold s-text-market-name">
                Sportsbook
              </span>
              <div className="s-w-16px s-h-16px">
                <span className="s-icon-info-circle s-text-market-sub-icon s-text-16px" />
              </div>
            </div>
            <span
              onClick={() =>
                handleActive(object?.eventId, object?.marketId, "SportBook")
              }
              className={`s-icon-arrow-down-sencodary s-text-12px s-transition-transform s-origin-center s-duration-300 s-text-global-font-default-light dark:s-text-global-font-default-dark s-transform ${
                activeOuter ? "s-rotate-180" : ""
              } `}
            />
          </div>
        </div>
        {activeOuter && (
          <div>
            {" "}
            <SportBookMatchInner
              updatedData={sportBook}
              parly={false}
              betSlipObject={betSlipObject}
              handelChange={handelChange}
              setSelected={setSelected}
              position={position}
              showBetDialog={showBetDialog}
              favouriteList={favouriteList}
              selected={selected}
              sportBookCheck={sportBookCheck}
              parlyBet={parlyBet}
              detail={object}
              active={active}
              setActive={setActive}
              addToFavioute={addToFavioute}
            />
            {/* <div className="s-bg-white dark:s-bg-black-800 s-rounded-b-lg">
          <div className="s-pb-3px">
            <div className="s-relative s-py-2 s-mb-0.5 s-flex s-justify-start s-items-center s-rounded-t-3px s-bg-black-100 dark:s-bg-black-700 s-min-h-35px">
              <span className="s-icon-star-solid s-ml-9px s-mr-4px s-pb-1px s-flex s-items-center s-text-16px s-text-global-font-default-light dark:s-text-global-font-default-dark" />
              <span className="s-px-2 s-flex-1 s-text-16px s-leading-120">
                Match Winner
              </span>
              <span className="s-icon-arrow-down-sencodary s-text-12px s-mr-3 s-justify-self-end s-text-global-font-default-light dark:s-text-global-font-default-dark s-transition-transform s-origin-center s-duration-300 s-transform s-rotate-180" />
            </div>
            <div className="s-grid s-grid-cols-2 s-gap-1px s-justify-center s-items-center s-relative">
              <div
                data-v-fae226aa
                className="s-py-1.5 s-text-center s-flex s-flex-col s-justify-center s-items-center s-bg-back-200 dark:s-bg-back-400-dark s-min-0 s-relative s-overflow-hidden s-rounded-b-3px s-min-h-53px"
                title="back"
              >
                <div
                  data-v-2f9c23fd
                  data-v-fae226aa
                  className="wrapper s-w-full s-h-full s-absolute s-overflow-hidden s-top-0 s-left-0 s-z-10"
                  style={{ "--0b879273": "0" }}
                >
                  <span
                    data-v-2f9c23fd
                    className="mask s-w-full s-h-full s-opacity-10 s-bg-black-900 s-absolute s-left-0 s-top-0"
                    style={{ display: "none" }}
                  />
                  <span
                    data-v-2f9c23fd
                    className="feedback s-block s-bg-white s-bg-opacity-25 s-rounded-full s-mix-blend-overlay s-absolute"
                    style={{ display: "none" }}
                  />
                </div>
                <p
                  data-v-fae226aa
                  className="s-text-17px s-font-bold s-pb-1 s-px-1 s-text-black-900"
                >
                  Tawang Titans
                </p>
                <p
                  data-v-fae226aa
                  className="s-text-11px s-text-black-900 s-min-h-10px"
                >
                  3.2
                </p>
                <div
                  data-v-fae226aa
                  className="s-rounded-full s-px-2 s-mt-0.5 s-bg-white s-bg-opacity-40"
                >
                  <div
                    data-v-fae226aa
                    className="s-text-12px s-leading-150 s-flex"
                    data-testid="forecast"
                  ></div>
                </div>
              </div>
              <div
                data-v-fae226aa
                className="s-py-1.5 s-text-center s-flex s-flex-col s-justify-center s-items-center s-bg-back-200 dark:s-bg-back-400-dark s-min-0 s-relative s-overflow-hidden s-rounded-b-3px s-min-h-53px"
                title="back"
              >
                <div
                  data-v-2f9c23fd
                  data-v-fae226aa
                  className="wrapper s-w-full s-h-full s-absolute s-overflow-hidden s-top-0 s-left-0 s-z-10"
                  style={{ "--0b879273": "0" }}
                >
                  <span
                    data-v-2f9c23fd
                    className="mask s-w-full s-h-full s-opacity-10 s-bg-black-900 s-absolute s-left-0 s-top-0"
                    style={{ display: "none" }}
                  />
                  <span
                    data-v-2f9c23fd
                    className="feedback s-block s-bg-white s-bg-opacity-25 s-rounded-full s-mix-blend-overlay s-absolute"
                    style={{ display: "none" }}
                  />
                </div>
                <p
                  data-v-fae226aa
                  className="s-text-17px s-font-bold s-pb-1 s-px-1 s-text-black-900"
                >
                  Kameng Kings
                </p>
                <p
                  data-v-fae226aa
                  className="s-text-11px s-text-black-900 s-min-h-10px"
                >
                  1.32
                </p>
                <div
                  data-v-fae226aa
                  className="s-rounded-full s-px-2 s-mt-0.5 s-bg-white s-bg-opacity-40"
                >
                  <div
                    data-v-fae226aa
                    className="s-text-12px s-leading-150 s-flex"
                    data-testid="forecast"
                  ></div>
                </div>
              </div>
              <div
                className="s-absolute s-w-full s-h-full s-bg-black-700 dark:s-bg-black-900 s-opacity-80 s-rounded-b-3px s-z-20"
                style={{ display: "none" }}
              >
                <span className="s-w-full s-h-full s-flex s-justify-center s-items-center s-text-white s-text-15px">
                  Suspend
                </span>
              </div>
            </div>
          </div>
        </div>
        <div className="s-bg-white dark:s-bg-black-800 s-rounded-b-lg">
          <div className="s-pb-3px">
            <div className="s-relative s-py-2 s-mb-0.5 s-flex s-justify-start s-items-center s-rounded-t-3px s-bg-black-100 dark:s-bg-black-700 s-min-h-35px">
              <span className="s-icon-star-solid s-ml-9px s-mr-4px s-pb-1px s-flex s-items-center s-text-16px s-text-global-font-default-light dark:s-text-global-font-default-dark" />
              <span className="s-px-2 s-flex-1 s-text-16px s-leading-120">
                1st Innings Kameng Kings 5th Wicket Dismissal Method (2 Way)
              </span>
              <span className="s-icon-arrow-down-sencodary s-text-12px s-mr-3 s-justify-self-end s-text-global-font-default-light dark:s-text-global-font-default-dark s-transition-transform s-origin-center s-duration-300 s-transform s-rotate-180" />
            </div>
            <div className="s-grid s-grid-cols-2 s-gap-1px s-justify-center s-items-center s-relative">
              <div
                data-v-fae226aa
                className="s-py-1.5 s-text-center s-flex s-flex-col s-justify-center s-items-center s-bg-back-200 dark:s-bg-back-400-dark s-min-0 s-relative s-overflow-hidden s-rounded-b-3px s-min-h-53px"
                title="back"
              >
                <div
                  data-v-2f9c23fd
                  data-v-fae226aa
                  className="wrapper s-w-full s-h-full s-absolute s-overflow-hidden s-top-0 s-left-0 s-z-10"
                  style={{ "--0b879273": "0" }}
                >
                  <span
                    data-v-2f9c23fd
                    className="mask s-w-full s-h-full s-opacity-10 s-bg-black-900 s-absolute s-left-0 s-top-0"
                    style={{ display: "none" }}
                  />
                  <span
                    data-v-2f9c23fd
                    className="feedback s-block s-bg-white s-bg-opacity-25 s-rounded-full s-mix-blend-overlay s-absolute"
                    style={{ display: "none" }}
                  />
                </div>
                <p
                  data-v-fae226aa
                  className="s-text-17px s-font-bold s-pb-1 s-px-1 s-text-black-900"
                >
                  Not Caught
                </p>
                <p
                  data-v-fae226aa
                  className="s-text-11px s-text-black-900 s-min-h-10px"
                >
                  2.02
                </p>
                <div
                  data-v-fae226aa
                  className="s-rounded-full s-px-2 s-mt-0.5 s-bg-white s-bg-opacity-40"
                >
                  <div
                    data-v-fae226aa
                    className="s-text-12px s-leading-150 s-flex"
                    data-testid="forecast"
                  ></div>
                </div>
              </div>
              <div
                data-v-fae226aa
                className="s-py-1.5 s-text-center s-flex s-flex-col s-justify-center s-items-center s-bg-back-200 dark:s-bg-back-400-dark s-min-0 s-relative s-overflow-hidden s-rounded-b-3px s-min-h-53px"
                title="back"
              >
                <div
                  data-v-2f9c23fd
                  data-v-fae226aa
                  className="wrapper s-w-full s-h-full s-absolute s-overflow-hidden s-top-0 s-left-0 s-z-10"
                  style={{ "--0b879273": "0" }}
                >
                  <span
                    data-v-2f9c23fd
                    className="mask s-w-full s-h-full s-opacity-10 s-bg-black-900 s-absolute s-left-0 s-top-0"
                    style={{ display: "none" }}
                  />
                  <span
                    data-v-2f9c23fd
                    className="feedback s-block s-bg-white s-bg-opacity-25 s-rounded-full s-mix-blend-overlay s-absolute"
                    style={{ display: "none" }}
                  />
                </div>
                <p
                  data-v-fae226aa
                  className="s-text-17px s-font-bold s-pb-1 s-px-1 s-text-black-900"
                >
                  Caught
                </p>
                <p
                  data-v-fae226aa
                  className="s-text-11px s-text-black-900 s-min-h-10px"
                >
                  1.65
                </p>
                <div
                  data-v-fae226aa
                  className="s-rounded-full s-px-2 s-mt-0.5 s-bg-white s-bg-opacity-40"
                >
                  <div
                    data-v-fae226aa
                    className="s-text-12px s-leading-150 s-flex"
                    data-testid="forecast"
                  ></div>
                </div>
              </div>
              <div
                className="s-absolute s-w-full s-h-full s-bg-black-700 dark:s-bg-black-900 s-opacity-80 s-rounded-b-3px s-z-20"
                style={{ display: "none" }}
              >
                <span className="s-w-full s-h-full s-flex s-justify-center s-items-center s-text-white s-text-15px">
                  Suspend
                </span>
              </div>
            </div>
          </div>
        </div> */}
            {/* <div className="s-flex s-gap-3px s-items-center s-justify-end s-text-black-500 s-pt-7px s-pb-1 s-mx-7px s-min-h-30px">
          <span className="s-icon-min-max s-text-14px" />
          <span className="s-text-12px">min</span>
          <mark className="s-text-12px s-font-bold s-bg-transparent s-text-black-500">
            119
          </mark>
        </div> */}
          </div>
        )}
      </div>
    )
  );
};

export default SportBookFav;
